// @see https://github.com/jaredhan418/vuetify-toast-snackbar-ng
// yarn add vuetify-toast-snackbar-ng
import Vue from 'vue';
import Vuetify, {VSnackbar, VBtn, VIcon} from 'vuetify/lib'
import vuetifyToast from 'vuetify-toast-snackbar-ng';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
})

Vue.use(vuetifyToast, {
  x: 'center',
  y: 'top',
});

export default vuetifyToast;
